<template>
  <div class="visible_spectrum">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="green lighten-1" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-file
          </v-icon>
        </v-btn>
      </template>
      <v-tooltip left color="green">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark small color="green" v-bind="attrs" v-on="on" @click="openSetupDialog(); getSetupPhoto()">
            <v-icon> mdi-image-search </v-icon>
          </v-btn>
        </template>
        <span>Setup Photo</span>
      </v-tooltip>

      <v-tooltip left color="indigo">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab dark small color="indigo" v-bind="attrs" v-on="on" @click="getLabManual">
            <v-icon>mdi-file-document</v-icon>
          </v-btn>
        </template>
        <span>Lab Maunal</span>
      </v-tooltip>      
    </v-speed-dial>
    <v-row>
      <ExperimentTitle />
    </v-row>
    <v-row>
      <v-col xs="12" sm="4">
        <v-card>
          <v-card-text>
            <div>{{ $t('experiment.camera.camera_1_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_1)">
              <img
                :src="api.camera_1.url"
                ref="camera1Image"
                style="width: 100%; height: auto; object-fit: cover;"
              />
            </div>
          </v-card-text>
        </v-card>        
        <v-expansion-panels v-model="controlPanel">
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Control</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="pb-3">
                <v-card-text>
                  <v-radio-group :disabled="( ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false) ||
                                ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false )" v-model="source_status" row dense>
                    <template v-slot:label>
                      <strong>Gas</strong>
                    </template>
                    <v-col cols="4">
                      <v-radio label="None" value="0" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Hydrogen (H)" value="1" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Helium (He)" value="2" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>              
                    <v-col cols="4">
                      <v-radio label="Nitrogen (N)" value="3" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Oxygen (O)" value="4" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Neon (Ne)" value="5" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Argon (Ar)" value="6" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Krypton (Kr)" value="7" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                    <v-col cols="4">
                      <v-radio label="Xenon (Xe)" value="8" @click="clientAction('setCommand', 'device_1', 'GAS|'+source_status);">
                      </v-radio>
                    </v-col>
                  </v-radio-group>
                  <div class="d-flex justify-end">
                    <v-btn class="mx-2"
                      :disabled="( ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false) ||
                                  ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false ) || source_status=='0'"
                      @click="clientAction('setChart', 'device_1', 'MEASURE|0')"
                    >
                      Measure
                    </v-btn>
                    <!--download-csv :data="api.chart">
                      <v-btn class="mx-2">Download</v-btn>
                    </download-csv-->
                  </div>
                  <v-overlay absolute :value="loop_flag">
                    <v-btn color="primary">
                      Operating
                      <v-progress-circular
                        indeterminate
                        size="12"
                        class="ma-4"
                      ></v-progress-circular>
                    </v-btn>
                  </v-overlay>
                  <v-overlay absolute :value="loading">
                    <v-btn color="primary">
                      Measuring

                      <v-progress-circular
                        indeterminate
                        size="12"
                        class="ma-4"
                      ></v-progress-circular>
                    </v-btn>
                  </v-overlay>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel2">
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Measure Result</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                v-if="$i18n.locale=='tc'"
                type="line"
                :options="options_chi"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <apexchart
                v-else
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <v-overlay absolute :value="loop_flag">
                <v-btn color="primary">
                  Operating
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>
              <v-overlay absolute :value="loading">
                <v-btn color="primary">
                  Measuring

                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>
            </v-expansion-panel-content>            
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Experiment Setup</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_camera" max-width="1000" >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeCameraDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.camera.dialog_header") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-3">
          <img :src="dialog_camera_src.url" fluid
            ref="cameraImagePop"
            style="width: 100%; height: auto; object-fit: cover;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
export default {
  name: "visible_spectrum",
  components: {
    ExperimentTitle,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      dialog_camera: false,
      dialog_camera_src: {},
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: 0,
      controlPanel2: 0,
      realTimePanel: 0,
      camera1_url: null,
      stored_data: [["Time", "Set 1 Temperature", "Set 2 Temperature"]],
      source_status: 0,
      loading: false,
      loop_flag: false,
      setup_photos: [],
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_1: "",
        camera_2: "",
      },      
      options: {
        width: "100%",
        stroke: {
          width: 1,
        },
        yaxis: {
          title: {
            text: "Intensity (count)",
          },
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
          },
          title: {
            text: "Wavelength (nm)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(2);
            }
          }
        },
        chart: {
          toolbar:{
            export: {
              csv: {
                headerCategory: 'x',
                headerValue: 'y',
              }
            }
          }
        }
      },
      options_chi: {
        width: "100%",
        stroke: {
          width: 1,
        },
        yaxis: {
          title: {
            text: "Intensity (count)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "Wavelength (nm)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(2);
            }
          }
        },
      },
      series: [
        {
          data: [

          ],
        },
      ],
    };
  },
  mounted: function () {    
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getValue("camera_1", function () {
      self.api.camera_1 = self.api.value;
      self.getValue("device_1", function () {
        self.source_status = self.api.value.gas.toString();
        self.getChart("device_1");
      });
    });
    self.checkOverrided();
    setInterval(function () {
      //loop distance value
      if (self.loop_flag) {
        self.getValue("device_1", function () {
          if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
            self.source_status = self.api.value.gas.toString();
          }
        });
      }
    }, 1000);
    self.experiment_name = "VISIBLE_SPECTRUM";
  },
  methods: {
    popCamera(camera) {
      var self = this;
      self.dialog_camera_src = camera;
      self.dialog_camera = true;
    },
    openCameraDialog(){
      var self = this;
      self.dialog_camera = true;
    },
    closeCameraDialog(){
      var self = this;
      self.dialog_camera = false;
      self.dialog_camera_src = {};
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
    clearCapture: function () {
      var self = this;
      if(self.capture==1){
        alert("Please stop capture before clearing graph.");
      }
      else {
        var r = confirm("Are you sure to clear the graph?");
        if (r == true) {
          self.clearChartMultiple("device_1", 2, "data_1", "data_2");
        }
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.camera1Image) {
      this.$refs.camera1Image.src = '';
    }
    if (this.$refs.camera2Image) {
      this.$refs.camera2Image.src = '';
    }
    if (this.$refs.cameraImagePop) {
      this.$refs.cameraImagePop.src = '';
    }
  },
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }
  
  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
